var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNotifications = function SvgNotifications(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "notifications_svg__a",
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#notifications_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M4.375 15.736a.6.6 0 0 1-.445-.18.6.6 0 0 1-.18-.445q0-.267.18-.446.18-.18.445-.179h.881V8.268q0-1.68 1.038-2.973a4.6 4.6 0 0 1 2.664-1.652v-.52q0-.434.304-.737.303-.304.737-.304t.738.304.305.738v.519a4.6 4.6 0 0 1 2.664 1.652 4.6 4.6 0 0 1 1.037 2.973v6.218h.882q.265 0 .445.18t.18.445-.18.445a.6.6 0 0 1-.445.18zm5.624 2.34q-.623 0-1.064-.443a1.45 1.45 0 0 1-.441-1.064h3.013q0 .623-.444 1.065-.443.442-1.064.442m-3.493-3.59h6.987V8.268q0-1.447-1.023-2.47A3.37 3.37 0 0 0 10 4.774q-1.447 0-2.47 1.024a3.37 3.37 0 0 0-1.024 2.47z"
  }))));
};
export default SvgNotifications;